/* Allure sticky add-to-cart reveal.
   The sticky bar section renders correctly but its own reveal script never applies
   the .is-on class, so the bar stayed translated off-screen at every scroll position.
   This binds a plain scroll listener instead: show past the bar's own data-threshold,
   hide again near the footer so it never sits on top of the footer content.
   Additive and idempotent - if the section's script is ever fixed, both simply set
   the same class. */
(function(){
  if(window.__allureSticky)return; window.__allureSticky=1;
  var d=document;

  function bind(root){
    var bars=(root||d).querySelectorAll('[data-alsticky-bar]:not([data-al-sticky-bound])');
    [].forEach.call(bars,function(bar){
      bar.setAttribute('data-al-sticky-bound','1');
      var th=parseInt(bar.getAttribute('data-threshold'),10);
      if(isNaN(th)||th<0)th=600;
      var raf=null;
      function apply(){
        raf=null;
        var y=window.scrollY||window.pageYOffset||0;
        var docH=Math.max(d.body.scrollHeight,d.documentElement.scrollHeight);
        var nearBottom=(y+window.innerHeight)>(docH-180);
        var on=(y>th)&&!nearBottom;
        bar.classList.toggle('is-on',on);
        bar.setAttribute('aria-hidden',on?'false':'true');
      }
      function schedule(){ if(raf===null) raf=requestAnimationFrame(apply); }
      window.addEventListener('scroll',schedule,{passive:true});
      window.addEventListener('resize',schedule);
      apply();
    });
  }

  if(d.readyState==='loading'){d.addEventListener('DOMContentLoaded',function(){bind()});}else{bind();}
  d.addEventListener('shopify:section:load',function(e){bind(e.target)});
  window.allureStickyBind=bind;
})();
